import * as React from "react";
import styles from "./SwimlaneContainer.module.css";

export interface SwimlaneContextValue {
  currentTime: number;
  duration: number;
  onSeek: (time: number) => void;
}

const SwimlaneContext = React.createContext<SwimlaneContextValue | null>(null);

export function useSwimlaneContext(): SwimlaneContextValue {
  const context = React.useContext(SwimlaneContext);
  if (!context) {
    throw new Error("useSwimlaneContext must be used within a SwimlaneContainer");
  }
  return context;
}

export interface SwimlaneContainerProps {
  currentTime: number;
  duration: number;
  onSeek: (time: number) => void;
  children: React.ReactNode;
  className?: string;
}

export function SwimlaneContainer({
  currentTime,
  duration,
  onSeek,
  children,
  className,
}: SwimlaneContainerProps) {
  const contextValue = React.useMemo(
    () => ({ currentTime, duration, onSeek }),
    [currentTime, duration, onSeek],
  );

  return (
    <SwimlaneContext.Provider value={contextValue}>
      <div className={`${styles.container}${className ? ` ${className}` : ""}`}>
        {children}
      </div>
    </SwimlaneContext.Provider>
  );
}
